import { Link, styled, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useRestaurantData } from "../../provider/RestaurantDataContext";
import CustomTitleBox from "../centralComponents/CustomTitleBox";

const StyledText = styled(Typography)(({ theme }) => ({
    color: 'white'
}));

export default function ContactPage() {
    const { t } = useTranslation();
    const { restaurantData: { address }, restaurantData } = useRestaurantData();

    return (
        <CustomTitleBox title={t('contact')}>
            <StyledText style={{ textAlign: 'center', marginBottom: '0.3rem' }}>
                <b>
                    {restaurantData.name}
                </b>
            </StyledText>
            {
                address ?
                    <>
                        {
                            address?.operator &&
                            <StyledText style={{ textAlign: 'center' }}>
                                {address.operator}
                            </StyledText>
                        }
                        <StyledText style={{ textAlign: 'center' }}>
                            {`${address.street} ${address.houseNumber}${address.dor ? '/' + address.dor : ''} - ${address.postal} ${address.town} - ${address.country}`}
                        </StyledText>
                        <StyledText style={{ textAlign: 'center' }}>
                            {
                                address?.phoneNumber &&
                                <>
                                    {`${t('phone')} `}
                                    <Link href={`tel:${address.phoneNumber}`}>
                                        {`${address.phoneNumber}`}
                                    </Link>
                                </>
                            }
                            {
                                address?.fax?.length > 0 &&
                                <>
                                    {` | ${t('fax')} `}
                                    <Link href={`fax:${address.fax}`}>
                                        {address.fax}
                                    </Link>
                                </>
                            }
                        </StyledText>
                    </> :
                    <>
                        <StyledText style={{ textAlign: 'center' }}>{t('noAddress')}</StyledText>
                    </>
            }
            {
                restaurantData.email &&
                <StyledText style={{ textAlign: 'center' }}>
                    {`${t('mail')} `}
                    <Link href={`mailto:${restaurantData.email}`}>
                        {`${restaurantData.email}`}
                    </Link>
                </StyledText>
            }
            {
                restaurantData.socialMedia?.website &&
                <StyledText style={{ textAlign: 'center', paddingBottom: '1rem', overflow: 'hidden' }}>
                    {`${t('website')} `}
                    <Link href={restaurantData.socialMedia?.website} target="_blank" rel="noopener noreferrer">
                        {`${restaurantData.socialMedia?.website}`}
                    </Link>
                </StyledText>
            }
        </CustomTitleBox>
    );
}